"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _TableBody = require("../TableBody/TableBody");
var _TableCell = require("../TableCell/TableCell");
var _TableHeader = require("../TableHeader/TableHeader");
var _TableHeaderCell = require("../TableHeaderCell/TableHeaderCell");
var _TableResponsive = require("../TableResponsive/TableResponsive");
var _TableRow = require("../TableRow/TableRow");
var _TableSortable = require("../TableSortable/TableSortable");
var _TableSortableHeaderCell = require("../TableSortableHeaderCell/TableSortableHeaderCell");
var _Table = require("./Table.context");
var _Table2 = require("./Table.styles");
/**
 * A native [`<table>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/table) element.
 *
 * @subcomponents ['Table.Row', 'Table.Sortable', 'Table.SortableHeaderCell']
 * @since 8.0.0
 */
var Table = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_Table.TableProvider, {
    value: {
      alignments: props.alignments,
      size: props.size
    }
  }, /*#__PURE__*/_react.default.createElement(_Table2.StyledTable, (0, _extends2.default)({
    ref: forwardedRef
  }, props)));
});
exports.Table = Table;
Table.displayName = 'Table';
Table.propTypes = {
  /**
   * Sets the horizontal alignment for each column.
   * Ex: `['left', 'left', 'center', 'right']`. You can
   * use the `align` prop on individual cells to override.
   */
  'alignments': _propTypes.default.arrayOf(_propTypes.default.string),
  /**
   * Styles the table based on one of its preset templates
   */
  'appearance': _propTypes.default.oneOf(['barebones', 'horizontal', 'grid', 'zebra']),
  /**
   * Be sure to provide a unique, accessible label for the table. This enables people using
   * assistive technologies to identify the purpose of the table and to
   * differentiate among multiple tables on the same page.
   */
  'aria-label': _propTypes.default.string.isRequired,
  /**
   * The table content
   */
  'children': _propTypes.default.node.isRequired,
  /**
   * Adjusts the table's density by changing the font size and spacing
   */
  'size': _propTypes.default.oneOf(Object.values(_constants.TABLE_SIZES))
};
Table.defaultProps = {
  alignments: [],
  size: _constants.TABLE_SIZES.md,
  appearance: 'grid'
};
Table.Body = _TableBody.TableBody;
Table.Cell = _TableCell.TableCell;
Table.Header = _TableHeader.TableHeader;
Table.HeaderCell = _TableHeaderCell.TableHeaderCell;
Table.Responsive = _TableResponsive.TableResponsive;
Table.Row = _TableRow.TableRow;
Table.Sortable = _TableSortable.TableSortable;
Table.SortableHeaderCell = _TableSortableHeaderCell.TableSortableHeaderCell;